module.exports = __webpack_public_path__ + "img/getting-started-grid-mob.ca0b177d.png";